// pacificDate.js
// Shared Pacific-time date-key helper for Knockout (and future modes).
//
// Produces the "YYYY-MM-DD" Pacific calendar-day string used as the suffix in
// Knockout Firestore document IDs — e.g. the shared player pool:
//   knockout_player_pools/Football_A_2026-06-06
//
// This MUST match the Cloud Functions byte-for-byte. knockoutShared.js builds
// the same key with exactly:
//   date.toLocaleDateString("en-CA", { timeZone: "America/Los_Angeles" })
// en-CA formats as YYYY-MM-DD, and pinning the timezone keeps the key correct no
// matter what timezone the user's browser is in. Never build this key from local
// date parts (e.g. new Date().getFullYear()/getMonth()/getDate()) — a user in
// another timezone would read the wrong day's player pool.
//
// NOTE: leaderboardService.startOfPacificDay() is a DIFFERENT helper. It returns
// a Date object (midnight Pacific) for Firestore range queries. This function
// returns the bare day-key STRING. They are not interchangeable.

export function pacificDateString(date = new Date()) {
  return date.toLocaleDateString("en-CA", { timeZone: "America/Los_Angeles" });
}
